import { styled } from '@linaria/react'
import theme from '../theme';

const Base = styled.p`
    margin: 0;

    color: ${theme.color.black.main};
    font-style: normal;
    font-weight: normal;
    line-height: 1.5;
`;

export const RegularTextBold = styled(Base)`
    font-size: ${theme.font.size.regular};
    font-weight: bold;
`;

export const MediumTextBold = styled(Base)`
    font-size: ${theme.font.size.medium2};
    font-weight: bold;
`;
